import { ApoQueryable } from '../modules/apo/models/apoRecord.model';
import { NoticeConditionModel } from '../modules/apo/models/NoticeConditionModel.model';
import { CapIDModel } from './CapIDModel.model';
import { DuplicatedAPOKeyModel } from './duplicatedAPOKeyModel.model';
import { TemplateAttributeModel } from './templateattributemodel.model';

export class ParcelModel  implements ApoQueryable {
    auditDate: Date;

    /// <remarks/>
    publicSourceSeqNBR: string;

    /// <remarks/>
    auditID: string;

    /// <remarks/>
    auditStatus: string;

    /// <remarks/>
    block: string;

    /// <remarks/>
    book: string;

    /// <remarks/>
    capID: CapIDModel;

    /// <remarks/>
    censusTract: string;

    /// <remarks/>
    councilDistrict: string;

    /// <remarks/>
    duplicatedAPOKeys: Array<DuplicatedAPOKeyModel>;

    /// <remarks/>
    eventID: number;

    /// <remarks/>
    exemptValue: number;

    /// <remarks/>
    //gisObjectList: Array<GISObjectModel>;

    /// <remarks/>
    gisSeqNo: number;

    /// <remarks/>
    /// Highest Notice placed on Record
    /// </remarks>
    hightestCondition: NoticeConditionModel;

    noticeConditions: NoticeConditionModel[];

    /// <remarks/>
    improvedValue: number;

    /// <remarks/>
    inspectionDistrict: string;

    /// <remarks/>
    landValue: number;

    /// <remarks/>
    legalDesc: string;

    /// <remarks/>
    lot: string;

    /// <remarks/>
    mapNo: string;

    /// <remarks/>
    mapRef: string;

    /// <remarks/>
    //noticeConditions: Array<NoticeConditionModel>

    /// <remarks/>
    page: string;

    /// <remarks/>
    parcel: string;

    /// <remarks/>
    parcelArea: number;

    /// <remarks/>
    parcelNumber: string;

    /// <remarks/>
    parcelStatus: string;

    /// <remarks/>
    planArea: string;

    /// <remarks/>
    primaryParcelFlag: string;

    /// <remarks/>
    range: string;

    /// <remarks/>
    refAddressTypes: Array<string>;

    /// <remarks/>
    resSubdivision: string;

    /// <remarks/>
    section: number;

    /// <remarks/>
    sourceSeqNumber: number;

    /// <remarks/>
    subdivision: string;

    /// <remarks/>
    supervisorDistrict: string;

    /// <remarks/>
    templates: Array<TemplateAttributeModel>;

    /// <remarks/>
    township: string;

    /// <remarks/>
    tract: string;

    /// <remarks/>
    UID: string;

    /// <remarks/>
    unmaskedParcelNumber: string;

}
